/**
 * QuickBooks Online integration API client.
 *
 * Mirrors ``backend/app/routers/integrations_quickbooks.py``. The
 * install endpoint returns the Intuit OAuth consent URL; the SPA does
 * ``window.location.href = authorize_url`` to follow it (same flow as
 * Slack/Teams — a real navigation so the state cookie rides along).
 */
import client from "./client";

export interface QuickBooksInstallResponse {
  authorize_url: string;
}

export interface QuickBooksStatusResponse {
  connected: boolean;
  ever_installed: boolean;
  realm_id: string | null;
  environment: string | null;
  connected_at: string | null;
  last_sync_at: string | null;
  last_sync_status: string | null;
  last_sync_error: string | null;
}

export interface QuickBooksSyncResponse {
  ok: boolean;
  result: Record<string, unknown> | null;
  detail: string | null;
}

export async function getQuickBooksInstallUrl(): Promise<QuickBooksInstallResponse> {
  const res = await client.get<QuickBooksInstallResponse>(
    "/integrations/quickbooks/install",
  );
  return res.data;
}

export async function getQuickBooksStatus(): Promise<QuickBooksStatusResponse> {
  const res = await client.get<QuickBooksStatusResponse>(
    "/integrations/quickbooks/status",
  );
  return res.data;
}

export async function disconnectQuickBooks(): Promise<QuickBooksStatusResponse> {
  const res = await client.delete<QuickBooksStatusResponse>(
    "/integrations/quickbooks/disconnect",
  );
  return res.data;
}

export async function syncQuickBooksNow(): Promise<QuickBooksSyncResponse> {
  const res = await client.post<QuickBooksSyncResponse>(
    "/integrations/quickbooks/sync",
  );
  return res.data;
}
